import { useState, useEffect } from "react";
import api from "../../../services/api";
import { maskFunction } from "../../../util/functions";
import { Content, Main, SubContent } from "../../../components/Layout";
import { Row, Col } from "react-bootstrap";
import Checkbox from "../../../components/Checkbox";
import { useParams, useNavigate, useOutletContext } from "react-router-dom";
import DatePicker from "../../../components/DatePicker";
import Loading from "../../../components/Loading";
import { toast } from "react-toastify";
import Slct from "../../../components/Slct";
import { IntegerNumber, InputDocument, Phone, Cep, File, InputText, InputEmail } from "../../../components/Input";
import Required from "../../../components/Required";
import useWrapper from "../../../hooks/useWrapper";
import Button from "../../../components/Button";
import CommentsTitle from "../../../components/Comments/Title";
import WriteComment from "../../../components/Comments/WriteComment";
import CommentSingle from "../../../components/Comments/Single";
import { listFinancial } from "../../../hooks/api/listFinancial";
import getCommercial from "../../../util/getCommercial";
import { ModalConfirm, ModalChangePass } from "../../../components/Modal";
import TraineeSubMenu from "../../../components/Submenu/TraineeSubMenu";
import StatusFlag from "../../../components/StatusFlag";
import { validateForm, validateStyle } from "../../../components/ValidateForm";
import useFormat from "../../../hooks/utils/useFormat";

export default function TraineesRegister() {
  const { me, config, token, permissions, setbreadcrumb } = useWrapper();
  const { stringToDate } = useFormat();
  const { traineesId } = useParams();

  useEffect(() => {
    !traineesId && setbreadcrumb([{ label: "Formandos", url: "/trainees" }, { label: "Novo Formando" }]);
  }, []);

  const [traineeNew, settraineeNew] = useState();
  const [isWaitingResponseNew, setisWaitingResponseNew] = useState(false);
  const {
    trainee = traineeNew,
    settrainee = settraineeNew,
    reloadTraineeData = () => {},
    isWaitingResponse = isWaitingResponseNew,
    setisWaitingResponse = setisWaitingResponseNew,
    isLoadingTraineesData,
    reloadTraineeComments,
    traineeComments,
    isLoadingTraineesComments,
    setisLoadingTraineesData,
  } = useOutletContext() || {};

  const [isLoadingCities, setisLoadingCities] = useState(false);
  const [isLoadingSlips, setisLoadingSlips] = useState(false);
  const [isLoadingSave, setisLoadingSave] = useState(false);

  useEffect(() => {
    setisWaitingResponse(isLoadingSlips || isLoadingSave);
  }, [isLoadingSlips, isLoadingSave]);

  const navigate = useNavigate();

  const [isLoadingEssencial, setisLoadingEssencial] = useState(true);
  const [states, setstates] = useState();
  const [commercials, setcommercials] = useState();
  useEffect(() => {
    (async () => {
      try {
        setisLoadingEssencial(true);
        const { data: _states } = await api.get("state");
        setstates({
          data: _states.map(__state => ({
            value: __state.id,
            label: __state.name,
            uf: __state.uf,
          })),
          uf: _states.map(__state => ({
            value: __state.id,
            label: __state.uf,
          })),
        });
        const _commercials = await getCommercial(null, null, "?is_class=1&joins=institution,course");
        setcommercials(_commercials);
      } catch (__error) {
        toast.error("Problemas ao tentar carregar dados essenciais.");
        console.log("__error", __error);
      } finally {
        setisLoadingEssencial(false);
      }
    })();
  }, []);

  const [cities, setcities] = useState();
  useEffect(() => {
    if (trainee?.state_id) {
      (async () => {
        try {
          setisLoadingCities(true);
          const { data: _cities } = await api.get(`cities/${trainee.state_id}`);
          setcities(
            _cities.map(__city => ({
              value: __city.id,
              label: __city.name,
            })),
          );
        } catch (__error) {
          console.log("__error", __error);
          toast.error("Erro ao tentar carregar as cidades.");
        } finally {
          setisLoadingCities(false);
        }
      })();
    }
  }, [trainee?.state_id]);

  const [saveAndUpdateSlips, setsaveAndUpdateSlips] = useState(false);
  const saveTrainee = async () => {
    const uploadFile = async (__file, __key) => {
      if (!__file) return;
      try {
        let _body = new FormData();
        _body.append("file", __file);
        const _response = await api.post("files", _body, {
          headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${token}`,
            [__key]: 1,
            size: __file.size,
          },
        });
        return _response;
      } catch (__error) {
        toast.error("Problemas ao subir o arquivo.");
        console.log("__error", __error);
      }
    };

    try {
      setisLoadingSave(true);
      // Files Upload
      let _files = trainee?.files || {};
      for (const __file of Object.entries(trainee?.files_to_upload || {})) {
        const { data: _file } = await uploadFile(__file[1], __file[0]);
        const _key = _file?.rg ? "rg" : "proof";
        _files[_key] = _file.id;
      }
      // Update Slips
      if (slipsToChangeDate?.length > 0) await changeSlips();
      // Trainee Data
      const _trainee_submit = {
        name: trainee?.name,
        email: trainee?.email,
        instagram: trainee?.instagram,
        cpf: trainee?.cpf,
        rg: trainee?.rg,
        ssp: trainee?.ssp,
        marital_status: trainee?.marital_status,
        gender: trainee?.gender,
        date_birth: stringToDate(trainee?.date_birth),
        phone: trainee?.phone,
        cell: trainee?.cell,
        legal_responsible1: trainee?.legal_responsible1,
        legal_cell1: trainee?.legal_cell1,
        legal_responsible2: trainee?.legal_responsible2,
        legal_cell2: trainee?.legal_cell2,
        cep: trainee?.cep,
        number: trainee?.number,
        address: trainee?.address,
        district: trainee?.district,
        complement: trainee?.complement,
        city_id: trainee?.city_id,
        state_id: trainee?.state_id,
        due_date: trainee?.due_date,
        commercial_id: trainee?.commercial_id,
        is_whatsapp: trainee?.is_whatsapp,
        is_member: trainee?.is_member,
        ssp_state_id: trainee?.ssp_state_id,
        contract_date: trainee?.contract_date,
        files: Object.values(_files) || [],
      };
      if (traineesId) {
        const { data: _new_trainee_data } = await api.put(`trainees/${traineesId}`, _trainee_submit, config);
        toast.success(`${_new_trainee_data.name} editado(a) com sucesso!`);
        reloadTraineeData();
      } else {
        const { data: _trainee } = await api.post("trainees", _trainee_submit, config);
        toast.success(`${trainee.name} criado(a) com sucesso!`);
        navigate(`/trainees/edit/${_trainee.id}`);
      }
    } catch (__error) {
      toast.error("Problemas ao tentar salvar o Formando.");
      console.log("__error", __error);
    } finally {
      setisLoadingSave(false);
    }
  };

  const [slipsToChangeDate, setslipsToChangeDate] = useState();
  const changePaymentDate = async __value => {
    settrainee({
      ...trainee,
      due_date: __value,
    });
    if (!trainee?.id || !!slipsToChangeDate) return false;
    try {
      setisLoadingSlips(true);
      const _trainee_slips = await listFinancial({
        me,
        config,
        query: `paginate=false&trainee_id=${trainee?.id}&status=nao-gerado`,
      });
      const _slips_in_process =
        _trainee_slips?.filter(__slip => __slip.status === "Em Processamento" && __slip.payment_for === "Contratado") ||
        [];
      setslipsToChangeDate(_slips_in_process);
    } catch (__error) {
      toast.error("Erro ao tentar carregar os pagamentos do formando.");
      console.log("__error", __error);
    } finally {
      setisLoadingSlips(false);
    }
  };

  const [modal, setmodal] = useState();
  const updateTraineeStatus = async __type => {
    try {
      setisLoadingTraineesData(true);
      setmodal();
      if (__type === "password_change") return;
      if (__type === "resend_email") {
        await api.post(`send-email-trainee/${traineesId}`, {}, config);
        toast.success("Email reenviado com sucesso!");
      }
      if (__type === "approve") {
        const { data: _trainee } = await api.put(`trainees/${traineesId}`, { approve_by_team: 1, active: 1 }, config);
        toast.success(`O Formando ${_trainee?.name} foi aprovado.`);
      }
      if (__type === "revoke_access") {
        const { data: _trainee } = await api.put(`trainees/${traineesId}`, { active: 0 }, config);
        toast.success(`O Formando ${_trainee?.name} teve seu acesso revogado.`);
      }
      if (__type === "restore_access") {
        const { data: _trainee } = await api.put(`trainees/${traineesId}`, { active: 1 }, config);
        toast.success(`O Formando ${_trainee?.name} teve seu acesso revogado.`);
      }
      if (__type === "cancel") {
        const { data: _trainee } = await api.delete(`trainees/${traineesId}`, config);
        toast.success(`O Formando ${trainee?.name} foi cancelado.`);
      }
      if (__type === "restore") {
        const { data: _trainee } = await api.put(`trainees/${traineesId}`, { cancel: 0 }, config);
        toast.success(`O Formando ${_trainee?.name} foi restaurado.`);
      }
    } catch (__error) {
      toast.error("Erro ao tentar atualizar os dados do formando.");
      console.log("__error", __error);
    } finally {
      reloadTraineeData();
      setisLoadingTraineesData(false);
    }
  };

  const changeSlips = async () => {
    try {
      const _today = new Date();
      const _first_new_date = new Date(
        slipsToChangeDate?.[0]?.due_date.getFullYear(),
        slipsToChangeDate?.[0]?.due_date.getMonth(),
        trainee.due_date,
      );
      const _jump_a_month = _today > _first_new_date ? 1 : 0;

      let _date_end = stringToDate(trainee?.commercials?.date_end);
      _date_end = new Date(_date_end.getFullYear(), _date_end.getMonth(), _date_end.getDate() - 1);

      let __i = 0;
      for (const __slip of slipsToChangeDate) {
        let _due_date = new Date(
          _first_new_date.getFullYear(),
          _first_new_date.getMonth() + _jump_a_month + __i,
          _first_new_date.getDate(),
        );
        __i++;
        if (_due_date > _date_end) {
          _due_date = _date_end;
        }
        await api.put(`paymentslips/${__slip.id}`, { due_date: _due_date }, config);
      }
      setslipsToChangeDate();
      toast.success("Vencimento das parcelas modificadas com sucesso!");
    } catch (__err) {
      toast.error("Problemas ao tentar modificar o vencimento das parcelas.");
      console.log("__err", __err);
    }
  };
  const [messageItem, setmessageItem] = useState();

  return (
    <>
      <Row>
        <Col>
          <Main>
            {!isLoadingTraineesData && !isLoadingEssencial ? (
              <Content noBG="true">
                <Row>
                  <Col>
                    <SubContent id="form_container">
                      <Row>
                        <Col>
                          <h2 className="mini-title">Dados Gerais:</h2>
                          <p className="small-label m-0">Informações essenciais de identificação e registro pessoal.</p>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={6}>
                          <span>
                            Nome Completo <Required />
                          </span>
                          <InputText
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.name}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                name: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            RG <Required />
                          </span>
                          <IntegerNumber
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.rg}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                rg: __ev,
                              });
                            }}
                            maxLength={20}
                          />
                        </Col>
                        <Col className="flex">
                          <span>
                            Orgão Emissor <Required />
                          </span>
                          <div className="ano-periodo">
                            <InputText
                              required={true}
                              disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                              value={trainee?.ssp}
                              onChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  ssp: __ev.target.value,
                                });
                              }}
                              maxLength={6}
                            />
                            <Slct
                              required={true}
                              isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                              options={states?.uf || []}
                              value={trainee?.ssp_state_id}
                              onChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  ssp_state_id: parseInt(__ev.value),
                                });
                              }}
                              placeholder="..."
                            />
                          </div>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <span>
                            CPF <Required />
                          </span>
                          <InputDocument
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.cpf}
                            type="cpf"
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                cpf: String(__ev),
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            Nascimento <Required />
                          </span>
                          <DatePicker
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            selected={trainee?.date_birth ? new Date(trainee?.date_birth) : null}
                            changeDate={__ev => {
                              settrainee({
                                ...trainee,
                                date_birth: maskFunction(__ev, "date"),
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            Estado Civil <Required />
                          </span>
                          <Slct
                            required={true}
                            isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            options={[
                              { label: "Solteiro(a)", value: "solteiro" },
                              { label: "Casado(a)", value: "casado" },
                            ]}
                            value={trainee?.marital_status}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                marital_status: __ev.value,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            Gênero <Required />
                          </span>
                          <Slct
                            required={true}
                            isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            options={[
                              { label: "Masculino", value: "M" },
                              { label: "Feminino", value: "F" },
                              { label: "Prefiro não informar", value: "NI" },
                            ]}
                            value={trainee?.gender}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                gender: __ev.value,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={6}>
                          <span>Foto Segurando RG</span>
                          <File
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            file_id={trainee?.files?.rg}
                            file_to_upload={trainee?.files_to_upload?.rg}
                            setFile={__file => {
                              settrainee({
                                ...trainee,
                                files_to_upload: {
                                  ...trainee?.files_to_upload,
                                  rg: __file,
                                },
                              });
                            }}
                            title="Foto Segurando RG"
                          />
                        </Col>
                      </Row>
                      <div className="divisor mt-3 mb-3"></div>
                      <Row>
                        <Col>
                          <h2 className="mini-title">Endereço:</h2>
                          <p className="small-label m-0">Informações detalhadas sobre o local de residência.</p>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <div className="position-relative">
                            <span>
                              CEP <Required />
                            </span>
                            <a
                              href="https://buscacepinter.correios.com.br/app/endereco/index.php?t"
                              rel="noopener noreferrer"
                              target="_blank"
                              className="im-nav"
                            >
                              Buscar CEP
                            </a>
                            <Cep
                              required={true}
                              disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                              value={trainee?.cep}
                              valueChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  cep: __ev,
                                });
                              }}
                              loadData={{
                                states: states?.data || [],
                                afterSuccess: __callback => {
                                  settrainee({
                                    ...trainee,
                                    address: __callback.address || trainee?.address,
                                    district: __callback.district || trainee?.district,
                                    city_id: __callback.city_id,
                                    state_id: __callback.state_id,
                                  });
                                },
                              }}
                            />
                          </div>
                        </Col>
                        <Col sm={2}>
                          <span>
                            Número <Required />
                          </span>
                          <IntegerNumber
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.number}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                number: __ev,
                              });
                            }}
                            maxLength={5}
                          />
                        </Col>
                        <Col sm={7}>
                          <span>
                            Endereço <Required />
                          </span>
                          <InputText
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.address}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                address: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <span>
                            Bairro <Required />
                          </span>
                          <InputText
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.district}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                district: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            Estado <Required />
                          </span>
                          <Slct
                            required={true}
                            isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            options={states?.data || []}
                            value={trainee?.state_id}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                state_id: __ev.value,
                                city_id: null,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                        <Col sm={3}>
                          <span>
                            Cidade <Required />
                          </span>
                          {!isLoadingCities ? (
                            <Slct
                              required={true}
                              isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                              options={cities || []}
                              value={trainee?.city_id}
                              onChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  city_id: __ev.value,
                                });
                              }}
                              placeholder="..."
                            />
                          ) : (
                            <Loading small />
                          )}
                        </Col>
                        <Col>
                          <span>Complemento</span>
                          <InputText
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.complement}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                complement: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={6}>
                          <span>Comprovante de Residência</span>
                          <File
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            file_id={trainee?.files?.proof}
                            file_to_upload={trainee?.files_to_upload?.proof}
                            setFile={__file => {
                              settrainee({
                                ...trainee,
                                files_to_upload: {
                                  ...trainee?.files_to_upload,
                                  proof: __file,
                                },
                              });
                            }}
                            title="Comprovante de Residência"
                          />
                        </Col>
                      </Row>
                      <div className="divisor mt-3 mb-3"></div>
                      <Row>
                        <Col>
                          <h2 className="mini-title">Contato:</h2>
                          <p className="small-label m-0">Canais disponíveis para comunicação e notificações.</p>
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <div className="position-relative">
                            <span>
                              Celular <Required />
                            </span>
                            <Phone
                              required={true}
                              disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                              value={trainee?.cell}
                              valueChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  cell: __ev,
                                });
                              }}
                            />
                            <label className="im-checkbox-2">
                              <Checkbox
                                disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                                name="is_whatsapp"
                                checked={trainee?.is_whatsapp || 0}
                                onChange={ev => {
                                  settrainee({
                                    ...trainee,
                                    is_whatsapp: ev.target.checked,
                                  });
                                }}
                              />
                              <span className="fs-12">WhatsApp?</span>
                            </label>
                          </div>
                        </Col>
                        <Col sm={3}>
                          <span>Outro Telefone</span>
                          <Phone
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.phone}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                phone: __ev,
                              });
                            }}
                          />
                        </Col>
                        <Col>
                          <span>
                            E-mail <Required />
                          </span>
                          <InputEmail
                            required={true}
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.email}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                email: __ev.target.value,
                              });
                            }}
                            placeholder="usuario@email.com"
                          />
                        </Col>
                        <Col>
                          <span>Instagram</span>
                          <InputText
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.instagram}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                instagram: __ev.target.value,
                              });
                            }}
                            placeholder="@usuario"
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col sm={3}>
                          <span>Responsável Legal 1</span>
                          <InputText
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.legal_responsible1}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                legal_responsible1: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>Tel. Responsável 1</span>
                          <Phone
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.legal_cell1}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                legal_cell1: __ev,
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>Responsável Legal 2</span>
                          <InputText
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.legal_responsible2}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                legal_responsible2: __ev.target.value,
                              });
                            }}
                          />
                        </Col>
                        <Col sm={3}>
                          <span>Tel. Responsável 2</span>
                          <Phone
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            value={trainee?.legal_cell2}
                            valueChange={__ev => {
                              settrainee({
                                ...trainee,
                                legal_cell2: __ev,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                      <div className="divisor mt-3 mb-3"></div>
                      <Row>
                        <Col>
                          <h2 className="mini-title">Dados Cadastrais/Contratuais:</h2>
                          <p className="small-label m-0">Detalhes da participação no evento e condições contratuais</p>
                        </Col>
                      </Row>
                      {!traineesId && (
                        <Row className="mt-2">
                          <Col sm={12}>
                            <span>
                              Turma <Required />
                            </span>
                            <Slct
                              required={true}
                              isDisabled={!!traineesId || !permissions?.trainee?.update || !!isWaitingResponse}
                              options={commercials || []}
                              value={trainee?.commercial_id}
                              onChange={__ev => {
                                settrainee({
                                  ...trainee,
                                  commercial_id: __ev.value,
                                });
                              }}
                              placeholder="..."
                            />
                          </Col>
                        </Row>
                      )}
                      <Row className="mt-2">
                        <Col sm={4}>
                          <span>
                            Comissão <Required />
                          </span>
                          <Slct
                            isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            options={[
                              { value: false, label: "Não" },
                              { value: true, label: "Sim" },
                            ]}
                            value={trainee?.is_member || false}
                            onChange={__ev => {
                              settrainee({
                                ...trainee,
                                is_member: __ev.value,
                              });
                            }}
                            placeholder="..."
                          />
                        </Col>
                        <Col sm={4}>
                          <span className="lince-input_label">
                            Vencimento das parcelas <Required />
                          </span>
                          {!isLoadingSlips ? (
                            <>
                              <Slct
                                required={true}
                                isDisabled={!permissions?.trainee?.update || !!isWaitingResponse}
                                options={[
                                  { value: 5, label: "Todo dia 05" },
                                  { value: 10, label: "Todo dia 10" },
                                  { value: 15, label: "Todo dia 15" },
                                  { value: 20, label: "Todo dia 20" },
                                  { value: 25, label: "Todo dia 25" },
                                ]}
                                value={trainee?.due_date}
                                onChange={__ev => {
                                  changePaymentDate(__ev.value);
                                }}
                                placeholder="..."
                              />
                              {slipsToChangeDate?.length > 0 && (
                                <p className="small-label mt-2 mb-0">
                                  <b>Atenção: </b>O vencimento de {slipsToChangeDate?.length} pagamento
                                  {slipsToChangeDate?.length !== 1 ? "s serão modificados" : " será modificado"} ao{" "}
                                  <b>Salvar</b>.
                                </p>
                              )}
                            </>
                          ) : (
                            <Loading small />
                          )}
                        </Col>
                        <Col sm={4}>
                          <span>Assinatura do Contrato</span>
                          <DatePicker
                            disabled={!permissions?.trainee?.update || !!isWaitingResponse}
                            selected={trainee?.contract_date ? new Date(trainee?.contract_date) : null}
                            changeDate={__ev => {
                              settrainee({
                                ...trainee,
                                contract_date: __ev,
                              });
                            }}
                          />
                        </Col>
                      </Row>
                      <Row className="mt-2">
                        <Col className="text-end">
                          {permissions?.trainee?.update && (
                            <Button
                              disabled={isWaitingResponse}
                              color="primary"
                              onClick={() => {
                                const _is_valid = validateForm(document.getElementById("form_container"));
                                if (!_is_valid) return;

                                if (slipsToChangeDate?.length > 0) {
                                  setsaveAndUpdateSlips(true);
                                  return false;
                                }
                                saveTrainee();
                              }}
                              loading={isLoadingSave}
                            >
                              {!!traineesId ? "Salvar Dados do Formando" : "Cadastrar Formando"}
                            </Button>
                          )}
                        </Col>
                      </Row>
                    </SubContent>
                  </Col>
                </Row>
                {!!traineesId && (
                  <SubContent className="mt-3">
                    <CommentsTitle title="Comentários" />
                    {!isLoadingTraineesComments ? (
                      <>
                        <div className="mt-4">
                          <WriteComment
                            value={messageItem}
                            onChange={__ev => {
                              setmessageItem(__ev.target.value);
                            }}
                            name="description"
                            placeholder="..."
                            buttonClick={async () => {
                              setmessageItem("");
                              await api.post(
                                "log-trainee",
                                {
                                  user_id: me.id,
                                  trainee_id: traineesId,
                                  commercial_id: trainee.commercial_id,
                                  message: messageItem,
                                  type: "comment",
                                },
                                config,
                              );
                              reloadTraineeComments();
                            }}
                            loading={isLoadingTraineesComments}
                          />
                        </div>
                        <div className="mt-4">
                          {traineeComments?.map(__comment => (
                            <CommentSingle
                              username={__comment.users?.username}
                              message={__comment.message}
                              created_at={__comment.created_at}
                            />
                          ))}
                        </div>
                      </>
                    ) : (
                      <Loading />
                    )}
                  </SubContent>
                )}
              </Content>
            ) : (
              <Content>
                <Loading />
              </Content>
            )}
          </Main>
        </Col>
        {!!traineesId && (
          <Col sm={3}>
            <TraineeSubMenu trainee={trainee} />
            {permissions?.trainee?.update && (
              <>
                <SubContent className="mt-3">
                  <h2 className="mini-title">Gerenciar Acesso:</h2>
                  <p className="small-label mb-2 mt-1">
                    <b>Atenção:</b> Certas ações podem causar alterações permanentes nos dados do formando.
                  </p>
                  <Button
                    color="primary"
                    onClick={() => {
                      setmodal("password_change");
                    }}
                    disabled={isWaitingResponse}
                    data-vertical="true"
                  >
                    Mudar Senha
                  </Button>
                  {trainee?.aceite_virtual !== 1 && (
                    <Button
                      color="primary"
                      onClick={() => {
                        setmodal("resend_email");
                      }}
                      disabled={isWaitingResponse}
                      data-vertical="true"
                    >
                      Reenviar Email de Acesso
                    </Button>
                  )}
                  {!!traineesId && (
                    <>
                      {trainee?.approve_by_team !== 1 && (
                        <Button
                          color="success"
                          onClick={() => {
                            setmodal("approve");
                          }}
                          disabled={isWaitingResponse}
                          data-vertical="true"
                        >
                          Aprovar Cadastro
                        </Button>
                      )}
                      {trainee?.approve_by_team === 1 && (
                        <>
                          {trainee?.active === 1 ? (
                            <Button
                              color="error"
                              onClick={() => {
                                setmodal("revoke_access");
                              }}
                              disabled={isWaitingResponse}
                              data-vertical="true"
                            >
                              Revogar Acesso
                            </Button>
                          ) : (
                            <Button
                              color="success"
                              onClick={() => {
                                setmodal("restore_access");
                              }}
                              disabled={isWaitingResponse}
                              data-vertical="true"
                            >
                              Restabelecer Acesso
                            </Button>
                          )}
                          {trainee?.cancel === 0 ? (
                            <Button
                              color="grey"
                              onClick={() => {
                                setmodal("cancel");
                              }}
                              disabled={isWaitingResponse}
                              data-vertical="true"
                            >
                              Encerrar Vínculo
                            </Button>
                          ) : (
                            <Button
                              color="grey"
                              onClick={() => {
                                setmodal("restore");
                              }}
                              disabled={isWaitingResponse}
                              data-vertical="true"
                            >
                              Restaurar Vínculo
                            </Button>
                          )}
                        </>
                      )}
                    </>
                  )}
                  <div className="mt-3">
                    <span className="small-label mr-2">Acesso:</span>
                    <StatusFlag status={trainee?.access} />
                  </div>
                  <div className="mt-1">
                    <span className="small-label mr-2">Vínculo:</span>
                    <StatusFlag status={trainee?.bond} />
                  </div>
                </SubContent>
              </>
            )}
          </Col>
        )}
      </Row>
      <ModalConfirm
        show={saveAndUpdateSlips}
        title="Salvar e Modificar Vencimentos"
        text={
          <>
            <p>
              Você selecionou uma <b>nova data para Vencimento das parcelas</b> de um formando que já possui o
              financeiro lançado.
            </p>
            <p>
              Tem certeza que deseja prosseguir e modificar a data de todos os pagamentos com o status{" "}
              <b>"Em Processamento"</b> para o <b>dia {trainee?.due_date}</b>?
            </p>
          </>
        }
        confirm={() => {
          saveTrainee();
        }}
        closeModal={() => {
          setsaveAndUpdateSlips(false);
        }}
        confirmText="Modificar Vencimentos"
        customYesNo={["Modificar Vencimentos e Salvar", "Não"]}
        colorScheme="primary"
        disableClose={isWaitingResponse}
        loading={isLoadingSave}
      />
      <ModalConfirm
        show={modal === "approve"}
        title="Aprovar Cadastro"
        text="Tem certeza que deseja aprovar o cadastro deste Formando?"
        confirm={() => {
          updateTraineeStatus("approve");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="success"
        disableClose={isWaitingResponse}
      />
      <ModalConfirm
        show={modal === "resend_email"}
        title="Reenviar Email de Aprovação"
        text="Tem certeza que deseja reenviar o link de Aprovação para este Formando?"
        confirm={() => {
          updateTraineeStatus("resend_email");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="primary"
        disableClose={isWaitingResponse}
        loading={isWaitingResponse}
      />
      <ModalConfirm
        show={modal === "restore_access"}
        title="Restabelecer Acesso do Formando"
        text="Tem certeza que deseja restabelecer o acesso deste Formando?"
        confirm={() => {
          updateTraineeStatus("restore_access");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="success"
        disableClose={isWaitingResponse}
      />
      <ModalConfirm
        show={modal === "restore"}
        title="Restaurar Vínculo com o Formando"
        text="Tem certeza que deseja restaurar vínculo com este Formando?"
        confirm={() => {
          updateTraineeStatus("restore");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="success"
        disableClose={isWaitingResponse}
      />
      <ModalConfirm
        show={modal === "revoke_access"}
        title="Revogar Acesso do Formando"
        text="Tem certeza que deseja revogar o acesso deste Formando?"
        confirmText="Revogar Acesso"
        confirm={() => {
          updateTraineeStatus("revoke_access");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="error"
        disableClose={isWaitingResponse}
      />
      <ModalConfirm
        show={modal === "cancel"}
        title="Encerrar Vínculo"
        text={
          <>
            <p>
              <b>Atenção: </b> Tem certeza que deseja cancelar este Formando? Todos os "Contratados" e "Financeiro"
              serão apagados!
            </p>
          </>
        }
        confirm={() => {
          updateTraineeStatus("cancel");
        }}
        closeModal={() => {
          setmodal();
        }}
        colorScheme="grey"
        confirmText="Encerrar Vínculo"
        disableClick={isWaitingResponse}
      />
      <ModalChangePass
        show={modal === "password_change"}
        user_id={traineesId}
        is_trainee={true}
        onHide={() => {
          setmodal();
        }}
      />
    </>
  );
}
